<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M22.94 15.19a1.5 1.5 0 012.12 0l15.5 15.5a1.5 1.5 0 01-2.12 2.12L24 18.372 9.56 32.811a1.5 1.5 0 01-2.12-2.122l15.5-15.5z"/></svg>